import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.div``

const StyledLockIcon = styled.span`
  cursor: pointer;
  svg {
    fill: #1d8afe;
  }
  :hover svg {
    font-weight: bold;
    fill: ${sv.color.cobalt};
  }
`

export default { Block, StyledLockIcon }
